import { fetchAuthSession } from 'aws-amplify/auth';

const getCognitoUserToken = async (): Promise<string> => {
    const { tokens } = await fetchAuthSession();
    return tokens?.idToken?.toString() ?? '';
};

export default getCognitoUserToken;
